import CommonClient from "./commonClient";
import Helpers from "../../commons/helpers";

import { Constants } from "../../constants/constants";
import { IRequestGetPagedCodename } from "../../containers/codename/list";

export interface IDataCreateUpdateCodename {
    id?: string;
    group?: string;
    code?: string;
    name?: string;
    shortName?: string;
    serviceCode?: string;
    organizationId?: string;
    status?: number;
    createUser?: string;
    updateUser?: string;
    createTime?: number | string;
    updateTime?: number | string;
}

const CodeNameService = {
    getByGroup: async (data: {
        group: string;
        serviceCode: string;
        organizationId?: string;
    }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await CommonClient().get(
            `${Constants.ApiPath.CODENAME.GET_BY_GROUP}?${query}`
        );
        return result.data.result;
    },

    async getPaged(data: IRequestGetPagedCodename) {
        const query = Helpers.handleFormatParams(data);
        const result = await CommonClient().get(
            `${Constants.ApiPath.CODENAME.GET_PAGED}?${query}`
        );
        return result.data.result;
    },

    async getDetail(id: string) {
        const result = await CommonClient().get(
            `${Constants.ApiPath.CODENAME.GET_DETAIL}/${id}`,
        );
        return result.data.result;
    },

    async create(data: IDataCreateUpdateCodename) {
        const result = await CommonClient().post(
            Constants.ApiPath.CODENAME.CREATE,
            data,
        );
        return result.data;
    },

    async update(data: IDataCreateUpdateCodename) {
        const result = await CommonClient().post(
            Constants.ApiPath.CODENAME.UPDATE,
            data,
        );
        return result.data;
    },

    async delete(id: string) {
        const result = await CommonClient().delete(
            `${Constants.ApiPath.CODENAME.DELETE}/${id}`,
        );
        return result.data;
    },

}

export default CodeNameService